export class FacebookConst {
  static displayColumns = () => {
    return [
      // {title: 'Avatar', key: 'avatar', display: true, allowSort: false, classes:''},
      {
        title: 'Tên page',
        key: 'page_name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Page ID',
        key: 'page_id',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Thể loại',
        key: 'category',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Hợp lệ',
        key: 'is_valid',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  };
  static displayAvatarColumns = avatar => {};
  static displayValidColumns = is_valid => {
    if (is_valid) {
      return `<span class="text-success"><i class="icon fa fa-check-square-o" aria-hidden="true" style="font-size: 24px"></i></span>`;
    } else {
      return `<span><i class="icon fa fa-check-square-o" aria-hidden="true" style="font-size: 24px"></i></span>`;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/facebook/facebook.const.ts